<template>
  <section
    class="section is-flex is-justify-content-center is-align-items-center"
    style="height: 100vh"
  >
    <div id="onfido-mount"></div>
  </section>
</template>

<script>
import { get, post } from "@/utils";
export default {
  name: "OnfidoSdkWrapper",
  data() {
    return {};
  },
  props: {
    enterprise_id: {
      type: String,
      required: true,
    },
    profile_id: {
      type: String,
      required: true,
    },
    first_name: {
      type: String,
      required: true,
    },
    last_name: {
      type: String,
      required: true,
    },
  },
  methods: {
    init() {
      let v = this;
      v.$root.loader(true);
      get("/onfido/wrapper/token", {
        enterprise_id: v.enterprise_id,
        profile_id: v.profile_id,
        first_name: v.first_name,
        last_name: v.last_name,
      })
        .then((response) => {
          let { token, onfido_request_uuid, settings } = response;
          let script_element = document.createElement("script");
          script_element.src = settings.url_sdk_js;
          script_element.charset = "utf-8";
          document.body.appendChild(script_element);
          let phrases = {};
          let steps = [];
          if (settings.is_welcome_active)
            steps.push({
              type: "welcome",
              options: {
                title: settings.welcome_title,
                descriptions: settings.welcome_description,
                nextButton: settings.welcome_button_text,
              },
            });
          if (settings.is_document_active)
            steps.push({
              type: "document",
              options: {
                documentTypes: {
                  driving_licence:
                    settings.document_driver_license_allowed || false,
                  national_identity_card:
                    settings.document_national_id_allowed || false,
                  residence_permit:
                    settings.document_residence_permit_allowed || false,
                },
                hideCountrySelection: settings.document_hide_country_selection,
              },
            });
          if (settings.is_face_active)
            steps.push({
              type: "face",
              options: {
                requestedVariant: settings.face_validation_type,
              },
            });
          if (settings.is_poa_active)
            steps.push({
              type: "poa",
            });
          if (settings.is_complete_active)
            steps.push({
              type: "complete",
              options: {
                message: settings.complete_message,
                submessage: settings.complete_sub_message,
              },
            });
          script_element.onload = function () {
            let onf = window.Onfido.init({
              token: token,
              language: {
                locale: "es_ES",
                phrases: phrases,
              },
              smsNumberCountryCode: "GT",
              containerId: "onfido-mount",
              steps: steps,
              onComplete: function (data) {
                post("/onfido/wrapper/complete", {
                  request_uuid: onfido_request_uuid,
                  sdk_data: data,
                })
                  .then(() => {
                    v.$emit("success", {
                      onfido_request_uuid: onfido_request_uuid,
                      sdk_data: data,
                    });
                    onf.tearDown();
                    console.log("Verification data submitted successfully");
                  })
                  .catch((error) => {
                    console.error(error);
                  });
              },
              onError: function (error) {
                console.error("error", error);
              },
            });
          };
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
};
</script>

<style scoped>
#onfido-mount {
  width: 100%;
  max-width: 600px;
}
</style>
